import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AppRoutes } from '../../types';

export const RequireAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="p-10 text-center opacity-50">Loading...</div>;
  }

  if (!user) {
    return <Navigate to={AppRoutes.LOGIN} state={{ from: location }} replace />;
  }

  return children;
};
